/*
 * IDUN: "Du kanske ocksa gillar" i varukorgsladan.
 *
 * Hamtar Shopifys produktrekommendationer for de (upp till) tva senast tillagda produkterna i varukorgen,
 * i ordningen: kompletterande (complementary, styrs i Search & Discovery) -> relaterade (related, automatiska)
 * -> reservlistan fran temainstallningen. Hoppar over det som redan ligger i varukorgen och visar max data-limit kort.
 * Svaren cachas per sidvisning sa att ladan inte hamtar samma sak flera ganger.
 */
(() => {
  if (customElements.get('cart-recommendations')) return;

  const cache = new Map();

  const fetchSection = (url) => {
    if (!cache.has(url)) {
      const request = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .catch(() => {
          cache.delete(url);
          return '';
        });

      cache.set(url, request);
    }

    return cache.get(url);
  };

  const parseCards = (html) => {
    if (!html) return [];
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('[data-product-id]'));
  };

  const splitIds = (value) => (value || '').split(',').map((id) => id.trim()).filter(Boolean);
  const unique = (ids) => Array.from(new Set(ids));

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.onCartChange = (event) => this.handleCartChange(event);
      document.addEventListener('cart:change', this.onCartChange);

      this.update(
        splitIds(this.dataset.cartProductIds),
        unique(splitIds(this.dataset.sourceProductIds))
      );
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.onCartChange);
    }

    async handleCartChange(event) {
      let cart = event && event.detail ? event.detail.cart : null;

      if (!cart || !Array.isArray(cart.items)) {
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
          cart = await response.json();
        } catch (error) {
          return;
        }
      }

      const items = cart.items || [];
      const cartIds = items.map((item) => String(item.product_id));
      const sourceIds = unique(items.filter((item) => item.final_line_price > 0).map((item) => String(item.product_id)));

      this.update(cartIds, sourceIds);
    }

    async update(cartIds, sourceIds) {
      this.token = (this.token || 0) + 1;
      const token = this.token;
      const limit = parseInt(this.dataset.limit, 10) || 3;
      const sources = sourceIds.slice(0, 2);
      const urls = [];

      ['complementary', 'related'].forEach((intent) => {
        sources.forEach((id) => {
          urls.push(`${this.dataset.url}?product_id=${encodeURIComponent(id)}&limit=10&intent=${intent}&section_id=${encodeURIComponent(this.dataset.sectionId)}`);
        });
      });

      const responses = await Promise.all(urls.map(fetchSection));
      if (token !== this.token || !this.isConnected) return;

      const fallbackTemplate = this.querySelector('template[data-fallback]');
      const fallbackCards = fallbackTemplate ? Array.from(fallbackTemplate.content.querySelectorAll('[data-product-id]')) : [];
      const candidates = responses.flatMap(parseCards).concat(fallbackCards);

      const excluded = new Set(cartIds);
      const picked = [];

      for (const card of candidates) {
        const id = card.getAttribute('data-product-id');
        if (!id || excluded.has(id)) continue;

        excluded.add(id);
        picked.push(card);
        if (picked.length >= limit) break;
      }

      const grid = this.querySelector('.cart-reco__grid');
      if (!grid) return;

      grid.replaceChildren(...picked.map((card) => document.importNode(card, true)));
      this.hidden = picked.length === 0;
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
})();
